import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './validations-actions';
import { ValidationInvocationState } from './validations.state';
import { ReviewAndSendActions } from 'src/app/margin-calculator/store/actions';

export const validationsKey = 'validations';
export interface ValidationsState {
    validations: ValidationInvocationState;
}

const initialState: ValidationInvocationState = {
    previousMarginId: 0,
    marginId: 0,
    marginValidations: [],
    error: ''
};

const validationsReducer = createReducer(
    initialState,
    on(Actions.getValidations, (state, action): ValidationInvocationState => {
        return {
            ...state,
            marginId: action.marginId
        };
    }),
    on(Actions.getValidationsSuccess, (state, action): ValidationInvocationState => {
        return {
            ...state,
            marginValidations: action.validations
        };
    }),
    on(ReviewAndSendActions.reviewAndSendClicked, (state): ValidationInvocationState => {
        return {
            ...state,
            marginValidations: []
        };
    }),
    on(Actions.saveValidations, (state, action): ValidationInvocationState => {
        return {
            ...state,
            marginId: action.marginId
        };
    }),
    on(Actions.setPreviousMarginId, (state, action): ValidationInvocationState => {
        return {
            ...state,
            previousMarginId: action.previousMarginId
        };
    })
);

export function reducer(state: ValidationInvocationState | undefined, action: Action) {
    return validationsReducer(state, action);
}
